<template>
    <div>
        <check-list :listArray="listArray"></check-list>
    </div>
</template>
<script>
    import CheckList from './check/checkList.vue';

    export default {
        data () {
            return {
                listArray: [
                    {
                        icon:'far fa-check-circle',
                        title:'פיתוח מהיר וממוקד',
                        text:'איפיון נקי וממוקד תהליך מרכזי, פיתוח בזמן קצר על מנת לצאת מהר לשוק וארכיטקטורת מערכת מיועדת צמיחה והתפתחות.',
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'פאנל ניהול לשליטה מירבית',
                        text:'השרביט בידיים שלכם. שליטה מלאה בכל נושא בחנות: ניהול פוסטים, משתמשים ועיצוב בלחיצת כפתור.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'עיצוב מותאם אישית ללא פשרות',
                        text:'חשוב לנו להביא לידי ביטוי את אופי החברה שלכם ולגרום למערכת לשדר בדיוק את מה שאתם מעוניינים לשדר.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'SEO',
                        text:'קידום אורגני בגוגל, אתר מהיר ומסודר שמנועי חיפוש ורשתות חברתיות יאהבו לקרוא ולקדם.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'Mobile First',
                        text:'זה הרבה יותר מרק רספונסיבי. כל מערכת שלנו מתוכננת בקפידה כדי לעבוד ולהיראות מדהים במכשירים הניידים.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'SSL',
                        text:'מערכות שלנו תמיד מגיעות מותאמות לפרוטוקול ההגנה המתקדם בשוק. גם משתמשכם בטוחים וגם החברה שלכם מצטיירת כרצינית ומקצועית.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'קשר עם הלקוח',
                        text:'קשר נוח ובריא עם הלקוחות יביא אתכם להצלחה. כל מערכת שלנו מצויידת בטופס יצירת קשר מתקדם ובקישורים בולטים לעמודים שלכם ברשתות החברתיות.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'אפליקציית SPA מהירה',
                        text:'כל מערכת שלנו היא בעצם אפליקציית Web חיה, דינמית ומהירה ששווה חוויית משתמש ברמה אחרת.'
                    },
                ],
            }
        },
        components: {
            'check-list': CheckList,
        }
    }
</script>
